export default class RoutingProvider {
  public static invokePushNewRouteWithRefresh(routingLink: string): void {
    window.location.href = routingLink;
  }
}
